import { Component, OnInit, } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Dep } from '../class/auth';
import { page }  from '../class/status';
import { ActivatedRoute,Router  } from '@angular/router';
import { environment } from '../../../environments/environment';
import { menulist } from '../class/status';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-blacklist',
  templateUrl: './blacklist.component.html',
  styleUrls: ['./blacklist.component.css']
})


export class BlacklistComponent implements OnInit {
  power:number = 0;
  user:any={};
  now:string = '0';
  search_gender:string = '-1';
  search_country:string = '-1';
  search_model:string = '';
  sort_model:string = 'desc';
  order_model:string = 'u.id';
  data:any=[];
  edit_data:any=[];
  loading:boolean=true;
  msg :string = '';
  link:string = environment.link;
  pageobj:page = {page:0,count:10,total_count:0};
  pageobjstr:string = JSON.parse(JSON.stringify(this.pageobj))
  blacklist_history: any[] = [];  // 存放封鎖/解鎖歷史
  historyPageObj: page = { page: 0, count: 10, total_count: 0 }; // 每頁 10 筆
  historyPageObjStr: string = JSON.parse(JSON.stringify(this.historyPageObj));
  historyData: any[] = []; // 存放封鎖/解鎖歷史的分頁資料
  old_is_enable: any = 0;

  generarr = ['性別','男生','女生'];

  menu_list:menulist = [
    {id:'0',name:'停權名單'},
    {id:'1',name:'懲處清單'},
  ];

  sort_obj:any = {column:'id',sort:'0'}

  tcontent : any= [
    {title:'姓名',content:'name',type:2},
    {title:'大頭貼',content:'profile_pic',type:1},
    {title:'電話',content:'phone_num'},
    {title:'性別',content:'gender',replaceArr:this.generarr},
    {title:'平台',content:'os_type',type:3},
    {title:'鑽石數',content:'diamond',format:'number'},
    // {title:'停權次數',content:'num'},
    {title:'停權理由',content:'block_reason'},
    {title:'停權日',content:'block_dt'},
    {title:'最後處理人',content:'emp_name'},
    {title:'操作與歷史',content:'gg',type:3},
 ];

  punish_list:menulist = [
    // {id:'-2',name:'執行取消'},
    // {id:'-1',name:'取消'},
    // {id:'0',name:'未執行'},
    {id:'1',name:'執行中'},
    {id:'2',name:'執行完畢'}
  ]

  punish_obj = {
    //'-2': '執行取消',
    //'-1': '取消',
    //'0': '未執行',
    '1': '執行中',
    '2': '執行完畢'
  };
  punish_status = '1';

  constructor(
    public httpClient: HttpClient,
    private  route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.init_list();
    this.power = Dep.auth.power_id;
    this.user = Dep.user;
  }

  choosetag(id){
    this.now = id;
    this.pageobj = {page:0,count:10,total_count:0};

    if(id=='0'){
        this.tcontent = [
            {title:'姓名',content:'name',type:2},
            {title:'大頭貼',content:'profile_pic',type:1},
            {title:'電話',content:'phone_num'},
            {title:'性別',content:'gender',replaceArr:this.generarr},
            {title:'平台',content:'os_type',type:3},
            {title:'鑽石數',content:'diamond',format:'number'},
            // {title:'停權次數',content:'num'},
            {title:'停權理由',content:'block_reason'},
            {title:'停權日',content:'block_dt'},
            {title:'最後處理人',content:'emp_name'},
            {title:'操作',content:'gg',type:3},
         ];      
        this.init_list();
    }else{
        this.tcontent = [
            {title:'姓名',content:'user_id',type:2},
            {title:'鑽石數',content:'diamond',format:'number',css:'min-width: 100px;',sort:'number'},
            {title:'懲罰時間(分鐘)',content:'bang_time',css:'min-width: 150px;',sort:'bang_time'},
            {title:'懲罰開始時間',content:'punish_start',css:'min-width: 80px;',sort:'punish_start'},
            {title:'懲罰結束時間',content:'punish_end'},
            {title:'狀態',content:'status',type:3},
            {title:'操作者',content:'emp_name'},
            {title:'懲處原因',content:'reason'},
            {title:'不良紀錄',content:'Nogood',type:3},
            {title:'操作',content:'gg',type:3},
         ];
        this.black_list();
    }
  }
  
  clicklink(uid){

    const url = this.router.serializeUrl(
        this.router.createUrlTree(['/admin_rtc/accuse', { uid: uid }])
    );
    
    window.open(url, '_blank');
  }

  clickpunsh(){
    Swal.fire({
        title: "確定要懲罰清空?",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "確定",
    }).then((result) => {
        if (result.isConfirmed) {
            const body = {page: this.pageobj.page,count:this.pageobj.count,type:1,punish_status:this.punish_status,sort_obj:this.sort_obj,data:this.edit_data,act:2};
            this.httpClient.post<any>("/get_black_list.php",body).subscribe(res => {
              this.loading = false;
              if(res.status){
                this.black_list();
                document.getElementById("ModalClose")?.click();
                Swal.fire("已清空完成!", "", "success");
              }
            });
        } 
    });
  }

  savepunsh(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,type:1,punish_status:this.punish_status,sort_obj:this.sort_obj,data:this.edit_data,act:1};
    this.httpClient.post<any>("/get_black_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.black_list();
        document.getElementById("ModalClose")?.click();
      }
    });
  }

  handlesortdata( value: any ): void {
    this.sort_obj = value;
    this.black_list();
  }

  black_list(){
    this.loading = true;
    const body = {page: this.pageobj.page,count:this.pageobj.count,type:1,punish_status:this.punish_status,sort_obj:this.sort_obj,search:this.search_model};
    this.httpClient.post<any>("/get_black_list.php",body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data;
        //this.country_list = res.country_list;
        this.pageobj.total_count = res.total_count
      }else{
        this.pageobj.total_count = 0
        this.data = [];
        //this.country_list = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
    });
  }

  init_list(){
    this.loading = true;
    const body = {
      page: this.pageobj.page,count:this.pageobj.count,
      search:this.search_model,
      sort:this.sort_model,
      gender:this.search_gender,
      country:this.search_country,
      order:this.order_model
    };
    this.httpClient.post<any>("/get_black_list.php", body).subscribe(res => {
      this.loading = false;
      if(res.status){
        this.data = res.data;
        //this.country_list = res.country_list;
        this.pageobj.total_count = res.total_count
        if(this.pageobj.page * this.pageobj.count >= res.total_count){ // 如果刪除後重新取得資料，並且頁數超過取得後的資料則將頁數設定為第一頁。
          this.pageobj.page -= 1;
        }
      }else{
        this.pageobj.total_count = 0
        this.data = [];
        //this.country_list = [];
      }
      this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj))
      console.log('res',res);
    });
  }

  callback(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.init_list();
    }
  }

  callback2(pageobj:page){
    if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
      this.pageobj = pageobj;
      this.black_list();
    }
  }

  historyCallback(pageObj: page) {
      if (JSON.stringify(this.historyPageObj) !== JSON.stringify(pageObj)) {
          this.historyPageObj = pageObj;
          this.loadHistoryPage(); // 重新載入對應的歷史資料
      }
  }

  loadHistoryPage() {
    if (!this.edit_data || !this.edit_data.history) return;

    const startIdx = this.historyPageObj.page * this.historyPageObj.count;
    const endIdx = startIdx + this.historyPageObj.count;

    this.historyData = this.edit_data.history.slice(startIdx, endIdx); // 截取當前分頁的歷史紀錄
    this.historyPageObj.total_count = this.edit_data.history.length;
    this.historyPageObjStr = JSON.parse(JSON.stringify(this.historyPageObj));
  }

  loadUserBlackHistory(user: any) {
    // console.log("✅ 按鈕被點擊了！收到的 user:", user);
      this.edit_data = user; // 設定當前使用者
      this.msg = ''; // 清空訊息
      this.old_is_enable = this.edit_data.is_enable;
      // 發送 API 請求，獲取該用戶的封鎖與解鎖歷史
      const body = { user_id: user.id, token: this.user.token };

      this.httpClient.post<any>("/get_user_black_history.php", body).subscribe(res => {
          if (res.status) {
              this.edit_data.history = res.data; // 存入歷史紀錄
          } else {
              this.edit_data.history = [];
          }
          this.historyPageObj.page = 0; // 重置頁碼
          this.loadHistoryPage(); // 載入分頁
      });
      // console.log("edit_data: " + this.edit_data);
  }

  save(){
    // console.log("發送請求前的 edit_data:", this.edit_data);  // 確保 unblock_reason 有被綁定
    if(this.edit_data.is_enable == 1 && (this.edit_data.unblock_reason == undefined || this.edit_data.unblock_reason == '')){
      alert('解鎖原因未填！');
    } else {
      this.loading = true;
      const body = {msg:this.msg, data:this.edit_data};
      this.httpClient.post<any>("/update_user.php",body).subscribe(res => { //原始使用updae_black_list.php
        this.loading = false;
        // this.init_list();
        console.log('res',res);
        document.getElementById("ModalClose")?.click();
      });
    }
  }
}
